<template>
  <v-window-item value="personal">
    <v-card-text>
      <v-card variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-account</v-icon>
          Personal Information
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-account-outline" title="Full Name" :subtitle="(userPersonalInfoData?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-translate" title="Name (Bangla)" :subtitle="(userPersonalInfoData?.name_bangla) || 'N/A'" />
                <v-list-item prepend-icon="mdi-card-account-details-outline" title="Employee Code" :subtitle="(userPersonalInfoData?.code) || 'N/A'" />
                <v-list-item prepend-icon="mdi-email-outline" title="Email" :subtitle="(userPersonalInfoData?.email) || 'N/A'" />
                <v-list-item prepend-icon="mdi-phone-outline" title="Mobile" :subtitle="(userPersonalInfoData?.mobile) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-account-outline" title="Date of Birth" :subtitle="(userPersonalInfoData?.date_of_birth) || 'N/A'" />
                <v-list-item prepend-icon="mdi-account-supervisor-outline" title="Father's Name" :subtitle="(userPersonalInfoData?.father_name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-account-supervisor" title="Mother's Name" :subtitle="(userPersonalInfoData?.mother_name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-gender-male-female" title="Gender" :subtitle="(userPersonalInfoData?.gender?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-water" title="Blood Group" :subtitle="(userPersonalInfoData?.blood_group?.name) || 'N/A'" />
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-mosque" title="Religion" :subtitle="(userPersonalInfoData?.religion?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-ring" title="Marital Status" :subtitle="(userPersonalInfoData?.marital_status?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-earth" title="Nationality" :subtitle="(userPersonalInfoData?.nationality) || 'N/A'" />
                <v-list-item prepend-icon="mdi-card-account-details" title="National ID" :subtitle="(userPersonalInfoData?.nid) || 'N/A'" />
                <v-list-item prepend-icon="mdi-passport" title="Passport Number" :subtitle="(userPersonalInfoData?.passport_no) || 'N/A'" />
                <v-list-item prepend-icon="mdi-human-male-height" title="Height" :subtitle="(userPersonalInfoData?.height) || 'N/A'" />
                <v-list-item prepend-icon="mdi-weight-kilogram" title="Weight" :subtitle="(userPersonalInfoData?.weight) || 'N/A'" />
                <v-list-item prepend-icon="mdi-account-alert-outline" title="Emergency Contact Person" :subtitle="(userPersonalInfoData?.emergency_contact_person) || 'N/A'" />
                <v-list-item prepend-icon="mdi-phone-alert-outline" title="Emergency Contact Number" :subtitle="(userPersonalInfoData?.emergency_contact_no) || 'N/A'" />
                <v-list-item prepend-icon="mdi-map-marker-outline" title="Permanent Address" :subtitle="(userPersonalInfoData?.permanent_address) || 'N/A'" />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
defineProps({
  userPersonalInfoData: {
    type: Object,
    default: () => ({})
  }
})
</script>
